import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Layout } from "@/components/Layout";
import Home from "./pages/Home";
import ChiSiamo from "./pages/ChiSiamo";
import AreaTecnica from "./pages/AreaTecnica";
import Protocolli from "./pages/Protocolli";
import FiabaDay from "./pages/FiabaDay";
import Concorsi from "./pages/Concorsi";
import Progettazione from "./pages/Progettazione";
import Segnalazioni from "./pages/Segnalazioni";
import Convenzioni from "./pages/Convenzioni";
import DiventaSocio from "./pages/DiventaSocio";
import Contatti from "./pages/Contatti";
import ServiziComuni from "./pages/ServiziComuni";
import ServiziAziende from "./pages/ServiziAziende";
import NotFound from "./pages/NotFound.tsx";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/area-tecnica" element={<AreaTecnica />} />
              <Route path="/protocolli-intesa" element={<Protocolli />} />
              <Route path="/fiaba-day" element={<FiabaDay />} />
              <Route path="/concorsi" element={<Concorsi />} />
              <Route path="/progettazione-accessibile" element={<Progettazione />} />
              <Route path="/segnalazioni" element={<Segnalazioni />} />
              <Route path="/convenzioni" element={<Convenzioni />} />
              <Route path="/servizi-comuni" element={<ServiziComuni />} />
              <Route path="/servizi-aziende" element={<ServiziAziende />} />
              <Route path="/diventa-socio" element={<DiventaSocio />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </TooltipProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;
